module.exports = __webpack_public_path__ + "static/media/SDG2.1c64f2f5.mp4";